export default "__VITE_ASSET__BlUROdF6__"